/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.5
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _navigationService = _interopRequireDefault(require("./navigationService"));
var _navigationHelpers = require("./navigationHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _navigationService$Ev = _navigationService["default"].EventType,
  ChangeFocus = _navigationService$Ev.ChangeFocus,
  NavigateFocus = _navigationService$Ev.NavigateFocus,
  Click = _navigationService$Ev.Click;
var focusManager = {
  isValidFocusId: _navigationHelpers.isValidFocusId,
  isFocused: function isFocused(focusId) {
    return focusManager.getCurrentFocus() === focusId;
  },
  isChildFocused: function isChildFocused(focusId) {
    var _navigationService$ge = _navigationService["default"].getData(),
      trail = _navigationService$ge.trail;
    if (trail === null) {
      console.error('Calling isChildFocused without enabling the trail: focusManager.setPersistTrail');
      return false;
    }
    return trail[0] !== focusId && trail.includes(focusId);
  },
  getCurrentFocus: function getCurrentFocus() {
    return _navigationService["default"].getData().currentFocus;
  },
  changeFocus: function changeFocus(eventData) {
    _navigationService["default"].trigger({
      eventType: ChangeFocus,
      eventData: eventData
    });
  },
  navigateFocus: function navigateFocus(eventData) {
    _navigationService["default"].trigger({
      eventType: NavigateFocus,
      eventData: eventData
    });
  },
  click: function click() {
    _navigationService["default"].trigger({
      eventType: Click
    });
  },
  setPersistTrail: _navigationService["default"].setPersistTrail,
  getTrail: function getTrail() {
    return _navigationService["default"].getData().trail;
  },
  listenToFocusChanged: function listenToFocusChanged(fn) {
    return _navigationService["default"].listenToFocusEvent({
      id: _navigationService["default"].Selectors.CurrentFocusChanged,
      fn: fn,
      shouldWarnOnExistingId: false
    });
  },
  unlistenToFocusChanged: function unlistenToFocusChanged(fn) {
    _navigationService["default"].unlistenToFocusEvent({
      id: _navigationService["default"].Selectors.CurrentFocusChanged,
      fn: fn
    });
  },
  listenToTrailBuilt: function listenToTrailBuilt(fn) {
    return _navigationService["default"].listenToFocusEvent({
      id: _navigationService["default"].Selectors.TrailBuilt,
      fn: fn,
      shouldWarnOnExistingId: false
    });
  },
  unlistenToTrailBuilt: function unlistenToTrailBuilt(fn) {
    _navigationService["default"].unlistenToFocusEvent({
      id: _navigationService["default"].Selectors.TrailBuilt,
      fn: fn
    });
  }
};
var _default = focusManager;
exports["default"] = _default;